import React from 'react';

import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import RoleDisplay from 'samples/experimental-roles/ExperimentalRoleDisplay';

interface FillPlateExperimentalRoleProps {
  typedValue: TypedValue;
}

export default function FillPlateExperimentalRole({
  typedValue,
}: FillPlateExperimentalRoleProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.JSON) {
    const {experimentalRole} = typedValue.jsonValue;
    if (experimentalRole == null) {
      return null;
    }
    return <RoleDisplay role={experimentalRole} />;
  }
  return null;
}
